import { render, staticRenderFns } from "./HomeHotRecommendBox.vue?vue&type=template&id=f8ca58a0&functional=true&"
import script from "./HomeHotRecommendBox.vue?vue&type=script&lang=js&"
export * from "./HomeHotRecommendBox.vue?vue&type=script&lang=js&"
import style0 from "./HomeHotRecommendBox.vue?vue&type=style&index=0&id=f8ca58a0&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports